export enum DISPATCH_STATUS {
  PENDING_PICKING = 1,
  PENDING_DISPATCH = 2,
  PENDING_RECEPTION = 3,
  PENDING_CUSTOMER_COLLECT = 4,
  PENDING_CUSTOMER_DISPATCH = 5,
  PENDING_COLLECTION = 6,
  DISPATCHED = 7,
  DELIVERED = 8,
  CANCELLED = 9,
  PRE_CANCELLED = 10
}
